<script lang="ts">
	//UI
	import { Card, DeleteIcon, InlineButton } from "@hitit/new_ui/src";
	import { createEventDispatcher } from "svelte";
	//Utils
	import { processingDate } from "@hitit/hub/src/v7/utils/Date";
	//Types
	//Props
	export let documentState = "";
	export let createdDate = "";
	export let editmode: boolean;
	export let title = "";
	export let id = "";
	//Constants
	const dispatch = createEventDispatcher();
	//Variables
	//Functions
	function itemClickHandler(id: string) {
		dispatch("ITEM_CLICK", id);
	}

	function itemDeleteHandler(id: string) {
		dispatch("ITEM_DELETE", id);
	}
	//Do
</script>

<div class="item">
	<Card noPadding>
		<button on:click|stopPropagation={() => itemClickHandler(id)}>
			<div class="container">
				<div class="content">
					<div class="head">
						<div
							class="status"
							class:publish={documentState === "PUBLISHED"}
							class:obsolate={documentState === "OBSOLETE"}
						/>
						<p class="create-date">
							{processingDate(createdDate, "yyyy.MM.DD") || ""}
						</p>
					</div>
					<p class="title">{title}</p>
				</div>
				{#if editmode}
					<div class="delete-box">
						<InlineButton on:click={() => itemDeleteHandler(id)}>
							<span class="delete-icon">
								<DeleteIcon fill={"#f66d6c"} />
							</span>
						</InlineButton>
					</div>
				{/if}
			</div>
		</button>
	</Card>
</div>

<style lang="scss">
	@import "../../../variables.scss";
	button {
		width: 100%;
		background-color: transparent;
		border: none;
		padding: 0px;
		&:hover {
			cursor: pointer;
		}
	}
	.container {
		display: flex;
		align-items: center;
		box-sizing: border-box;
		position: relative;
		padding: 10px;
		gap: 16px;
		color: #46474b;
		width: 100%;
		text-align: left;

		.content {
			display: flex;
			flex-direction: column;
			gap: 16px;
			width: 100%;
			letter-spacing: -0.64px;
		}

		.head {
			display: flex;
			align-items: center;
			gap: 10px;
			width: 100%;
			.status {
				min-width: 15px;
				height: 15px;
				background-color: #bcbfc3;
				border-radius: 15px;
				&.publish {
					background-color: #44e4ae;
				}

				&.obsolate {
					background-color: #ffce00;
				}
			}

			.create-date {
				font-weight: 200;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
				margin-top: -1px;
			}
		}

		.title {
			font-weight: 500;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.delete-box {
			position: absolute;
			top: 10px;
			right: 10px;
			.delete-icon {
				width: 20px;
				height: 20px;
			}
		}
	}

	@include DesktopSize {
		.container {
			padding: 20px;
			flex-direction: row;
			justify-content: space-between;
			height: auto;

			.content {
				width: calc(100% - 36px);
				letter-spacing: -0.8px;
				gap: 10px;
			}
			.head {
				width: auto;
				font-size: 1.25rem;

				.create-date {
					margin-top: -2px;
				}
			}
			.title {
				flex-grow: 1;
				font-size: 1.25rem;
			}
			.delete-box {
				position: static;
				.delete-icon {
					width: 26px;
					height: 26.2px;
				}
			}
		}
	}
</style>
